module.exports = __webpack_public_path__ + "static/img/cargo.8709c5ff.svg";